import React from "react";
import PropTypes from "prop-types";
import styles from "./close-button.module.scss";

export const CloseButton = ({ onClick, ariaLabel }) => {
    return (
        <button
            onClick={() => onClick()}
            className={styles.closeButton}
            aria-label={ariaLabel}
            tabIndex={1}
        >
            <span>&times;</span>
        </button>
    );
};

CloseButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/ui/close-button/CloseButton.js